// This function might not always return the correct item because there might be several lines with the same partNo,
// ex. packages might contain product X and then we add product X outside the package, this function will return the first.
export default (id, items) => {
    const foundItems = items.filter((item) => item.part_no === id);

    return foundItems[foundItems.length - 1];
};
